(() => {
  const POWER_OPTION_KEYWORDS = ['power', 'prescription', 'pwr', 'sph', 'degree', '度数'];

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  function valueLooksZero(value) {
    const normalized = normalize(value);
    if (!normalized) return false;

    if (
      normalized.includes('noprescription') ||
      normalized.includes('nonprescription') ||
      normalized.includes('withoutprescription') ||
      normalized.includes('plano') ||
      normalized.includes('平光')
    ) {
      return true;
    }

    const numberMatch = normalized.match(/^[+-]?\d+(\.\d+)?/);
    if (numberMatch) {
      const numericValue = parseFloat(numberMatch[0]);
      if (!isNaN(numericValue) && numericValue === 0) return true;
    }

    return normalized.split('/').some((part) => {
      const p = part.trim();

      if (
        p.includes('noprescription') ||
        p.includes('nonprescription') ||
        p.includes('withoutprescription') ||
        p.includes('plano') ||
        p.includes('平光')
      ) {
        return true;
      }

      const match = p.match(/^[+-]?\d+(\.\d+)?/);
      if (!match) return false;

      const num = parseFloat(match[0]);
      return !isNaN(num) && num === 0;
    });
  }

  function getForms(root) {
    const forms = [];

    if (root instanceof Element && root.matches('form[data-type="add-to-cart-form"]')) {
      forms.push(root);
    }

    if (root instanceof Element) {
      forms.push(...root.querySelectorAll('form[data-type="add-to-cart-form"]'));
    } else if (root === document) {
      forms.push(...document.querySelectorAll('form[data-type="add-to-cart-form"]'));
    }

    return forms;
  }

  function initPrescriptionGate(root) {
    const forms = getForms(root);

    forms.forEach((form) => {
      if (form.dataset.rxInit === 'true') return;

      const gate = form.querySelector('.prescription-gate');
      if (!gate) return;

      const checkbox = gate.querySelector('.prescription-gate__checkbox');
      const error = gate.querySelector('.prescription-gate__error');
      const propertyInput = gate.querySelector('input[name="properties[Prescription confirmation]"]');
      const dataEl = form.querySelector('script[id^="PrescriptionGateData-"]');

      if (!checkbox || !error || !propertyInput || !dataEl) return;

      let productData = {};
      try {
        productData = JSON.parse(dataEl.textContent || '{}');
      } catch (e) {
        return;
      }

      form.dataset.rxInit = 'true';

      function getCurrentVariantId() {
        const input = form.querySelector('input[name="id"]');
        return input ? String(input.value) : '';
      }

      function getCurrentVariant() {
        const currentId = getCurrentVariantId();
        return (productData.variants || []).find((v) => String(v.id) === currentId) || null;
      }

      function getPowerCandidates(variant) {
        if (!variant) return [];

        const optionNames = productData.optionNames || [];
        const optionValues = variant.options || [];
        const matched = [];

        optionNames.forEach((name, index) => {
          const normalizedName = normalize(name);
          const isPowerField = POWER_OPTION_KEYWORDS.some((keyword) => normalizedName.includes(keyword));
          if (isPowerField) matched.push(optionValues[index]);
        });

        if (matched.length) return matched;

        return [...optionValues, variant.title];
      }

      function requiresPrescription(variant) {
        if (!variant) return false;
        return !getPowerCandidates(variant).some(valueLooksZero);
      }

      function setBlocked(blocked) {
        const addToCartButtons = form.querySelectorAll('button[name="add"], .add-to-cart-button');

        addToCartButtons.forEach((button) => {
          button.classList.toggle('is-prescription-blocked', blocked);
          button.setAttribute('aria-disabled', blocked ? 'true' : 'false');

          if (button.tagName === 'BUTTON') {
            button.disabled = blocked;
          }
        });

        const paymentWrapper = form.querySelector('.shopify-payment-button');
        if (paymentWrapper) {
          paymentWrapper.classList.toggle('is-prescription-blocked', blocked);
          paymentWrapper.setAttribute('aria-disabled', blocked ? 'true' : 'false');
        }
      }

      function refreshGate(showError = false) {
        const currentVariant = getCurrentVariant();
        const required = requiresPrescription(currentVariant);

        gate.hidden = !required;

        if (!required) {
          checkbox.checked = false;
          propertyInput.value = '';
          propertyInput.disabled = true;
          error.hidden = true;
          setBlocked(false);
          return;
        }

        propertyInput.disabled = false;
        propertyInput.value = checkbox.checked ? 'Confirmed by customer' : '';
        setBlocked(!checkbox.checked);
        error.hidden = !(showError && !checkbox.checked);
      }

      checkbox.addEventListener('change', () => {
        refreshGate(false);
      });

      form.addEventListener(
        'submit',
        (event) => {
          const currentVariant = getCurrentVariant();

          if (requiresPrescription(currentVariant) && !checkbox.checked) {
            event.preventDefault();
            event.stopPropagation();
            refreshGate(true);
            checkbox.focus();
          }
        },
        true
      );

      form.addEventListener(
        'click',
        (event) => {
          const clickedButton = event.target.closest(
            'button[name="add"], .add-to-cart-button, .shopify-payment-button, .shopify-payment-button *'
          );

          if (!clickedButton) return;

          const currentVariant = getCurrentVariant();

          if (requiresPrescription(currentVariant) && !checkbox.checked) {
            event.preventDefault();
            event.stopPropagation();
            refreshGate(true);
            checkbox.focus();
          }
        },
        true
      );

      form.addEventListener('change', () => {
        setTimeout(() => refreshGate(false), 0);
        setTimeout(() => refreshGate(false), 80);
      });

      let lastVariantId = getCurrentVariantId();
      setInterval(() => {
        const currentVariantId = getCurrentVariantId();
        if (currentVariantId !== lastVariantId) {
          lastVariantId = currentVariantId;
          refreshGate(false);
        }
      }, 200);

      refreshGate(false);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initPrescriptionGate(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          initPrescriptionGate(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();